import React from "react";

// Shows a spinner until a generated PDF blob url is ready, then the PDF in an
// iframe whose src only changes when a new PDF is generated. Use with hooks
// like useInvoicePDF / usePayablePDF instead of react-pdf's PDFViewer, which
// re-renders the PDF (and reloads the iframe) on every parent re-render.
const PDFPreviewFrame = ({ url, error, title = "PDF", height = "90vh" }) => {
  if (url) {
    return (
      <iframe
        src={url}
        title={title}
        style={{ width: "100%", height, border: "none" }}
      />
    );
  }

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center gap-2 text-secondary"
      style={{ width: "100%", height }}
    >
      {error ? (
        <span>Failed to load the PDF.</span>
      ) : (
        <>
          <span className="spinner-border" role="status" aria-hidden="true" />
          <span>Generating PDF...</span>
        </>
      )}
    </div>
  );
};

export default PDFPreviewFrame;
